
import {Promocao} from '@/soganhei'

import http from '@/http/service'

export default function CriarPromocao(payload=Promocao){
 
    if(payload.idPromocao == undefined){
        return http.post("/parceiro/promocoes",payload)
    }else{
        return http.put(`/parceiro/promocoes/${payload.idPromocao}`,payload)
    }

}